import styles from 'legacy/common/components/form/Form.module.scss';

import { useState } from 'react';
import classnames from 'classnames';
import ReactCodeInput from 'react-verification-code-input';
import { useTranslation } from 'react-i18next';

import FormWrapper from '../FormWrapper';
import Button, { ButtonType } from 'legacy/common/components/button/Button';

type SignUpConfirmationProps = {
  onSubmit: (code: string) => void;
  onResendCode: () => void;
  isLoading: boolean;
  errorMessage: string;
  isResendingCode: boolean;
  onBackClick: () => void;
};

export const SignUpConfirmationModalContent: React.FC<
  SignUpConfirmationProps
> = ({
  isLoading,
  errorMessage,
  isResendingCode,
  onSubmit,
  onResendCode,
  onBackClick
}) => (
  <SignUpConfirmation
    isLoading={isLoading}
    errorMessage={errorMessage}
    isResendingCode={isResendingCode}
    onSubmit={onSubmit}
    onResendCode={onResendCode}
    onBackClick={onBackClick}
    isModal
  />
);

const SignUpConfirmation: React.FC<
  SignUpConfirmationProps & { isModal?: boolean }
> = ({
  isLoading,
  errorMessage,
  isResendingCode,
  onSubmit,
  onResendCode,
  onBackClick,
  isModal = false
}) => {
  const { t } = useTranslation('auth');
  const [code, setCode] = useState('');

  const method = t('confirmation.methodPhone');

  return (
    <FormWrapper
      showBack
      onBackClick={onBackClick}
      title={t('confirmation.title')}
      subtitle={t('confirmation.signUpSubtitle', { method })}
      isModal={isModal}
    >
      <div className={styles.group}>
        <p className={styles.submitError}>{errorMessage}</p>
      </div>
      <div className={styles.group}>
        <p className={classnames(styles.label, styles.small)}>
          {t('confirmation.verificationCodeLabel')}
        </p>
        <div className={`${styles.codeInputContainer} font-family-inter!`}>
          <ReactCodeInput
            disabled={isResendingCode}
            fields={4}
            fieldWidth={45}
            fieldHeight={60}
            onComplete={(val) => {
              onSubmit(val);
              setCode(val);
            }}
            className={styles.codeInput}
            placeholder={['#', '#', '#', '#']}
          />
        </div>
      </div>
      <div className={styles.FormGroup}>
        <Button
          disabled={!code}
          loading={isLoading}
          type={ButtonType.Primary}
          onClick={() => {
            onSubmit(code);
          }}
        >
          {t('confirmation.confirmCodeButton')}
        </Button>
      </div>
      <div className={styles.group}>
        {isResendingCode ? (
          t('confirmation.sendingAgain')
        ) : (
          <>
            {t('confirmation.didntReceive')}
            <span
              className={styles.actionItem}
              data-testid="button-send-again"
              onClick={onResendCode}
            >
              {t('confirmation.sendAgain')}
            </span>
          </>
        )}
      </div>
    </FormWrapper>
  );
};

export default SignUpConfirmation;
